export default __webpack_public_path__ + "static/users-380a56069a5f6b9bdb59e56395b8db94.png";